import { Route, Routes } from 'react-router-dom';

import { ChampionshipStateData } from 'modules/championship/store/championship';
import { useStagesFetch } from 'modules/championship/ui/hooks/use-stages-fetch';
import StageInfoForm from './stage-info-form';
import StageRoutes from './stage-routes';
import Stages from './stages';

interface StagesRoutesProps {
  championship: ChampionshipStateData;
}

/**
 * Вкладка «Этапы»: `/championships/:id/steps/...`.
 *
 * Здесь же грузятся этапы — один запрос на всё поддерево, потому что список,
 * форма этапа и календарь матчей читают одни и те же данные.
 *
 * Статический `create` в react-router v6 ранжируется выше динамического `:stageId`,
 * поэтому порядок объявления роутов роли не играет.
 */
const StagesRoutes = ({ championship }: StagesRoutesProps) => {
  const { isReady } = useStagesFetch(championship.id);

  return (
    <Routes>
      <Route
        path="create"
        element={
          <div className="w-full px-6">
            <StageInfoForm championshipId={championship.id} stage={null} />
          </div>
        }
      />
      {/* Ловит и мусор вроде `/steps/abcd`: там `StageRoutes` уводит на список. */}
      <Route path=":stageId/*" element={<StageRoutes championship={championship} isStagesReady={isReady} />} />
      <Route index element={<Stages championship={championship} isStagesReady={isReady} />} />
    </Routes>
  );
};

export default StagesRoutes;
